// useNseSectors.js
// Calls the getNseSectors Cloud Function and returns live NSE sector index data.
// Each entry: { name, price, change, changePct }
// Fetches once on mount (useRef guard). Cloud Function caches for 5 min server-side.

import { useState, useEffect, useRef } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/firebase';

const useNseSectors = () => {
    const [data, setData]       = useState(null);   // array of sector objects
    const [loading, setLoading] = useState(true);
    const [error, setError]     = useState(null);
    // stale = served from a saved snapshot (last-known-good) because the live fetch failed
    const [stale, setStale]     = useState(false);
    const [fetchedAt, setFetchedAt] = useState(null);
    const hasFetched            = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;

        const fetch = async () => {
            try {
                const getNseSectors = httpsCallable(functions, 'getNseSectors');
                const result = await getNseSectors();
                setData(result.data.sectors ?? []);
                setStale(!!result.data.stale);
                setFetchedAt(result.data.fetchedAt ?? null);
            } catch (err) {
                console.error('useNseSectors: failed to fetch sector data', err);
                setError(err.message ?? 'Failed to load sector data');
            } finally {
                setLoading(false);
            }
        };

        fetch();
    }, []);

    return { data, loading, error, stale, fetchedAt };
};

export default useNseSectors;
